import styles from "./QuestionRadio.module.css";

interface QuestionRadioProps {
	options: string[];
	value: string | null;
	onChange: (value: string) => void;
	t: (key: string) => string;
	questionId: string;
}

export function QuestionRadio({
	options,
	value,
	onChange,
	t,
	questionId,
}: QuestionRadioProps) {
	return (
		<div
			role="radiogroup"
			aria-label={questionId}
			className={styles.radioGroup}
		>
			{options.map((option) => {
				const isSelected = value === option;
				return (
					<button
						key={option}
						type="button"
						className={styles.radioRow}
						onClick={() => onChange(option)}
					>
						<div
							className={
								isSelected ? styles.radioSelected : styles.radioUnselected
							}
						/>
						<span className={styles.radioLabel}>{t(option)}</span>
					</button>
				);
			})}
		</div>
	);
}
